import { withCssModulesClassNames } from '../../../common/nextMigrationHelpers';
import Configuration from './StyleSelectorConfiguration';

// eslint-disable-next-line import/no-named-default
import { default as styles } from '../../../scss/components/StyleSelectorConfigurations.module.scss';

import { ProductStyleConfigurationCMS } from './types';

const cssModulesClassNames = withCssModulesClassNames(styles);

export interface StyleSelectorConfigurationsProps {
  configurations: ProductStyleConfigurationCMS[];
  onSelect: (configuration: ProductStyleConfigurationCMS) => void;
  activeConfiguration: ProductStyleConfigurationCMS | null;
}

const StyleSelectorConfigurations = ({
  configurations,
  onSelect,
  activeConfiguration,
}: StyleSelectorConfigurationsProps) => (
  <div className={cssModulesClassNames('style-configurations__wrapper')}>
    <h5>Select base configuration</h5>
    <div className={cssModulesClassNames('style-configurations')}>
      {configurations.map((configuration) => (
        <Configuration
          key={configuration.id}
          configuration={configuration}
          onClick={() => onSelect(configuration)}
          isActive={activeConfiguration?.id === configuration.id}
        />
      ))}
    </div>
  </div>
);

export default StyleSelectorConfigurations;
